/* eslint-disable react/require-default-props */
import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import useQuickLinks from '../hooks/useQuickLinks';
import { dataModel } from '../util/data-model';

export const QuickLinksContext = createContext();

const QuickLinksProvider = ({
  children, componentId = '', linkList = undefined, slotContentId: slotName = '', mediaCollectionIndex = 0,
  label = undefined, pillVariant = 'outline'
}) => {
  const { links, setLinks } = useQuickLinks(componentId, linkList, slotName, mediaCollectionIndex);
  return (
    <QuickLinksContext.Provider value={{
      links, setLinks, componentId, label, pillVariant
    }}
    >
      {children}
    </QuickLinksContext.Provider>
  );
};

QuickLinksProvider.dataModel = dataModel;
QuickLinksProvider.displayName = 'QuickLinksProvider';

QuickLinksProvider.propTypes = {
  children: PropTypes.node.isRequired,
  componentId: PropTypes.string,
  linkList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    href: PropTypes.string,
    label: PropTypes.string,
  })),
  slotContentId: PropTypes.string,
  mediaCollectionIndex: PropTypes.number,
  label: PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string,
  }),
  pillVariant: PropTypes.oneOf(['outline', 'filled']),
};

export default QuickLinksProvider;
